import { render, staticRenderFns } from "./AdminOfficeDetails.vue?vue&type=template&id=28a905de&scoped=true"
import script from "./AdminOfficeDetails.vue?vue&type=script&lang=js"
export * from "./AdminOfficeDetails.vue?vue&type=script&lang=js"
import style0 from "./AdminOfficeDetails.vue?vue&type=style&index=0&id=28a905de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a905de",
  null
  
)

export default component.exports